export default __webpack_public_path__ + "static/media/mv.f2af32e1.jpg";